import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AuthenticationFacade } from '@symphony-solo/domain/authentication/src';
import { CompanyGroupFacade } from '@symphony-solo/domain/company-group/src';
import { AppConfigService } from '@symphony-solo/domain/company-group/src';
import { SIDE_MENU } from '@symphony-solo/shared/utils/src';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'symphony-solo-menu-header',
  templateUrl: './menu-header.component.html',
  styleUrls: ['./menu-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuHeaderComponent implements OnInit {
  @Input() public title = null;
  @Input() public hideHomeButton: boolean;
  public companyLogo: string;

  public viewModel$: Observable<any> = combineLatest([this.companyGroupFacade.companyGroupInfo$]).pipe(
    map(([companyGroupInfo]) => {
      return {
        companyGroupInfo,
      };
    })
  );

  constructor(
    public authenticationFacade: AuthenticationFacade,
    private navController: NavController,
    private appConfigService: AppConfigService,
    private companyGroupFacade: CompanyGroupFacade
  ) {}

  public ngOnInit(): void {
    if (this.appConfigService.getCompanyGroup) {
      const company = this.appConfigService.getCompanyGroup;
      this.companyLogo = company.logoImageURL;
    }
  }

  public navigateToHome(): void {
    // this.navController.navigateRoot(SELECT_APP_SIMPLE_TABS);
    this.authenticationFacade.goHomeSuccess();
  }

  public openMenu(): void {
    this.navController.navigateForward(SIDE_MENU);
  }
}
